import React, { FC, useState } from 'react';
import { Title } from '../developers/page-components/Title';
import { ButtonComponent } from '../ButtonComponent';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { ChangePasswordForm } from './forms/ChangePasswordForm';
import { useTranslation } from 'react-i18next';
// import { VerificationForm } from './forms/VerificationForm';

export const AccountSecurityChangePassword: FC = () => {
	const { t } = useTranslation();

	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});
	// const [isNumberModalOpen, setIsNumberModalOpen] = useState<boolean>(false);
	const [isChangePassModalOpen, setIsChangePassModalOpen] = useState<boolean>(false);

	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

	const handleSuccess = (): void => {
		setIsChangePassModalOpen(false);
		setModalState({
			isOpen: true,
			modalTitle: 'Change password',
			content: (
				<div className="fs-6">
					Password was successfully changed!
				</div>
			),
			confirmButtonText: t('PARTNERS.SUCCESS_BTN_NAME'),
			minHeight: 100,
			onConfirm: closeModal,
			onClose: closeModal
		});
	};

	const handleError = (): void => {
		setIsChangePassModalOpen(false);
		setModalState({
			isOpen: true,
			modalTitle: 'Change password',
			content: (
				<div className="fs-6">
					Failed changing password
				</div>
			),
			confirmButtonText: t('PARTNERS.FAIL_BTN_NAME'),
			minHeight: 100,
			onConfirm: () => {
				closeModal();
				setIsChangePassModalOpen(true);
			},
			onClose: closeModal
		});
	};

	// const openVerificationModal = (): void => {
	// 	setModalState({
	// 		isOpen: true,
	// 		modalTitle: 'Verification required',
	// 		contentClassName: 'd-block',
	// 		minHeight: 170,
	// 		backdrop: 'static',
	// 		content: <VerificationForm
	// 			closeModal={closeModal}
	// 			onContinue={(): void => {
	// 				setIsNumberModalOpen(true);
	// 				closeModal();
	// 			}}/>
	// 	});
	// };

	return (
		<>
			<div className="mb-5 mb-xl-0 w-md-50">
				<Title title="Password" additionalClass="fs-6 fw-bolder mb-5"/>
				<ButtonComponent
					buttonName="Change password"
					additionalClass="btn-sm"
					onButtonClick={(): void => setIsChangePassModalOpen(true)}
				/>
			</div>
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>

			<ModalWindow
				isOpen={isChangePassModalOpen}
				modalTitle='Change password'
				onClose={(): void => setIsChangePassModalOpen(false)}
				contentClassName='d-block'
				backdrop="static"
				minHeight={375}
				content={
					<ChangePasswordForm
						closeModal={(): void => setIsChangePassModalOpen(false)}
						onSuccess={handleSuccess}
						onError={handleError}
					/>
				}
			/>
		</>
	);
};
